"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumLabelTypeNameUtil = void 0;
const AltiumLabelTypes_1 = require("./AltiumLabelTypes");
class AltiumLabelTypeNameUtil {
    static getLabelTypeName(labelType, name, argument) {
        const args = [labelType, name];
        if (argument !== undefined) {
            args.push(argument);
        }
        return `LABEL_NAME(${args.map((a) => a.replace(/,/g, '\0$_comma_$\0')).join(',')})`;
    }
    static parseLabelTypeName(labelTypeName) {
        if (!labelTypeName.startsWith('LABEL_NAME(') || !labelTypeName.endsWith(')')) {
            throw new Error(`Not a label type name string`);
        }
        let match = labelTypeName.match(/^LABEL_NAME\((.+),(.+),(.+)\)$/);
        if (!match) {
            match = labelTypeName.match(/^LABEL_NAME\((.+),(.+)\)$/);
            if (!match) {
                throw new Error(`Invalid label type name: ${labelTypeName}`);
            }
        }
        function uncomma(s) {
            return s?.replace(/\0\$_comma_\$\0/g, ',');
        }
        return {
            labelType: AltiumLabelTypes_1.AltiumLabelTypeNameGeneratorSchema.parse(uncomma(match[1])),
            name: uncomma(match[2]),
            argument: uncomma(match[3]),
        };
    }
    static maybeDereferenceLabelName(name, ensureType) {
        let derefed;
        try {
            derefed = AltiumLabelTypeNameUtil.parseLabelTypeName(name);
        }
        catch {
            return name;
        }
        if (ensureType) {
            if (derefed.labelType !== ensureType) {
                throw new Error(`Expected label type ${ensureType}, got ${derefed.labelType}`);
            }
        }
        return derefed.name;
    }
}
exports.AltiumLabelTypeNameUtil = AltiumLabelTypeNameUtil;
//# sourceMappingURL=AltiumLabelTypeNameUtil.js.map